import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Layout from "~shared/layout/Layout";
import MainData from "./MainData";
import { getDetalleCotizacion } from "./actions";
import { paths, multicotizacionesPath } from "~constants/referenceNames";
import DetalleCotizacionTable from "~business/cotizaciones/detalleCotizacionTable/DetalleCotizacionTable";
import UnexpectedError from "~styled/errorPages/UnexpectedError";
import pxToRem from "~libs/pxToRem";
import { format } from "date-fns";
import { es } from "date-fns/esm/locale";
import { DetalleCotizacionView } from "../types";

interface DetalleCotizacionSlice {
  detalleCotizacion: DetalleCotizacionView | null;
  failed: boolean;
}

const useReduxSelector = () =>
  useSelector<any, DetalleCotizacionSlice>((state) => ({
    detalleCotizacion: state.detalleCotizacionReducer.detalleCotizacion,
    failed: state.detalleCotizacionReducer.failed,
  }));

interface DetalleCotizacionProps {
  match: { params: { id: string } };
}

const DetalleCotizacion: React.FC<DetalleCotizacionProps> = ({ match }) => {
  const { detalleCotizacion, failed } = useReduxSelector();
  const history = useHistory();

  const dispatch = useDispatch();
  const id = match.params.id;

  useEffect(() => {
    dispatch(getDetalleCotizacion(id) as any);
  }, [dispatch, id]);

  const backAction = () => {
    history.push(paths[multicotizacionesPath]);
  };

  if (failed) return <UnexpectedError />;

  return (
    <Layout
      title={"Detalle de Cotización"}
      subtitle={
        detalleCotizacion
          ? format(
              Date.parse(detalleCotizacion.fecha),
              "dd'/'MM'/'yyyy HH:mm",
              { locale: es }
            )
          : null
      }
      backAction={backAction}
      data={
        detalleCotizacion ? (
          <MainData detalleCotizacion={detalleCotizacion} />
        ) : null
      }
    >
      <div style={{ paddingTop: pxToRem(30) }}>
        <DetalleCotizacionTable
          isPending={false}
          detalleCotizacion={detalleCotizacion}
        />
      </div>
    </Layout>
  );
};

export default DetalleCotizacion;
